import { render, staticRenderFns } from "./drawerTianxiedanhao.vue?vue&type=template&id=310c5d82&scoped=true&"
import script from "./drawerTianxiedanhao.vue?vue&type=script&lang=js&"
export * from "./drawerTianxiedanhao.vue?vue&type=script&lang=js&"
import style0 from "./drawerTianxiedanhao.vue?vue&type=style&index=0&id=310c5d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310c5d82",
  null
  
)

export default component.exports